<template>
  <div style="display: flex; align-items: center; width: 100%;">
    <el-input
      :placeholder="placeholder"
      v-model="innerValue"
      class="input-with-select"
      :disabled="disabled"
      clearable
      style="flex: 1;"
    >
      <el-upload
          slot="append"
          ref="fileUpload"
          :auto-upload="true"
          :show-file-list="false"
          :file-list="uploadFileList"
          :limit="1"
          :http-request="handleUploadFile"
      >
        <el-button slot="trigger" size="small" type="primary" :loading="uploading" icon="el-icon-upload">{{buttonText}}</el-button>
      </el-upload>
    </el-input>

  </div>
</template>

<script>
/**
 * 文件上传链接选择器
 * @author PeterLee
 * @since 2026-03-04
 */
import {uploadOssFile} from "@/api/ossApi";
import {Message} from 'element-ui';

export default {
  name: "FileLinkUploadSelect",
  //设置v-model绑定对象和自动更新响应方法
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请输入文件路径或上传文件"
    },
    buttonText: {
      type: String,
      // 可以为“文件上传”字样
      default: ""
    },
    objectKeyPrefix: {
      type: String,
      default: "fileUpload"
    },
    maxSize: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      uploadFileList: [],
      uploading: false,
      currentUploadFile: null
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleUploadFile(options) {
      if (!options.file) {
        Message.warning('请选择要上传的文件');
        return;
      }

      if (this.maxSize > 0 && options.file.size > this.maxSize) {
        Message.error(`文件过大（${(options.file.size / 1024 / 1024).toFixed(1)}MB），请压缩后上传（限制 ${(this.maxSize / 1024 / 1024).toFixed(0)}MB）`);
        return;
      }

      this.uploading = true;
      
      const timestamp = Date.now();
      const fileName = options.file.name;
      const objectKey = `${this.objectKeyPrefix}/${timestamp}_${fileName}`;
      
      const formData = new FormData();
      formData.append('file', options.file);
      formData.append('objectKey', objectKey);
      
      uploadOssFile(formData).then(res => {
        if (res.code === 200) {
          this.innerValue = res.data;
          Message.success('文件上传成功');
          this.uploadFileList = [];
          this.currentUploadFile = null;
          this.$emit('upload-success', res.data);
        } else {
          Message.error('文件上传失败：' + (res.msg || '未知错误'));
        }
      }).catch(err => {
        console.error('文件上传失败：', err);
        const httpStatus = err && err.status;
        const msg = (err && err.message) || (err && err.statusText) || (httpStatus ? `HTTP ${httpStatus}` : '网络错误');
        Message.error('文件上传失败：' + msg);
        if (httpStatus === 413) {
          Message.warning('文件大小超过服务端限制，请联系管理员增大 nginx client_max_body_size');
        }
      }).finally(() => {
        this.uploading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
